import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { switchMap } from 'rxjs';
import { hexToRgba } from 'src/app/common/colorUtils';
import { LabelModel } from 'src/app/models/api/common';
import { LabelsHttpService } from 'src/app/services/httpServices/labelsHttpService/labels-http.service';
import { NotificationsService } from 'src/app/services/infra/notifications/notifications.service';
import { StoreService } from 'src/app/services/infra/store/store.service';
import {
  DeleteLabelDialogComponent,
  DeleteLabelDialogInputData,
} from '../delete-label-dialog/delete-label-dialog.component';

export class EditLabelDialogInputData {
  public label: LabelModel;
}

@Component({
  selector: 'app-edit-label-dialog',
  templateUrl: './edit-label-dialog.component.html',
  styleUrls: ['./edit-label-dialog.component.scss'],
})
export class EditLabelDialogComponent {
  private readonly _copyOfLabel: LabelModel;

  constructor(
    public dialogRef: MatDialogRef<EditLabelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public inputData: EditLabelDialogInputData,
    private readonly _labelsHttpService: LabelsHttpService,
    private readonly _store: StoreService,
    private readonly _notificationService: NotificationsService,
    public matDialog: MatDialog
  ) {
    this._copyOfLabel = { ...this.inputData.label };
  }

  public onClose() {
    this.dialogRef.close();
  }

  public onNameChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.inputData.label.displayName = value.trim();
  }

  public onColorChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.inputData.label.color = value;
  }

  public editButtonClick() {
    this._labelsHttpService
      .editLabel(this.inputData.label)
      .pipe(switchMap(() => this._store.updateLabels()))
      .subscribe({
        next: () => {
          this._notificationService.success('Label edited successfully');
          this.onClose();
        },
        error: () => {
          this._notificationService.error('Failed to edit label');
        },
      });
  }

  public deleteButtonClick() {
    this.dialogRef.close();
    this.matDialog.open(DeleteLabelDialogComponent, {
      data: { label: this._copyOfLabel } as DeleteLabelDialogInputData,
      disableClose: false,
      autoFocus: false,
      panelClass: 'sidepanel-dialog-container',
      width: '350px',
    });
  }

  public getLabelTransparentBackgroundColor(): string {
    return hexToRgba(this.inputData.label.color, 0.3);
  }
}
